import { getTemplate } from "../template-helper.js";
import { runInContext } from "../binding.js";

const COMPONENT_NAME = "z-map" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    return getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class MapComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }


            init(){
                this.div = this.querySelector(".z-map-container") ;
                if(!this.div){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    this.div = this.querySelector(".z-map-container") ;
                }


                const rootNode = this.getRootNode();
                if(!rootNode || !rootNode.getElementById){ 
                    return  ;
                }

                this.doImport().then(()=>{
                    if(!this.ownerDocument || !this.ownerDocument.defaultView){
                        return ;
                    }
                    const L = this.ownerDocument.defaultView.L ;
                    if(!L){ return ; }

                    L.Icon.Default.imagePath = "/node_modules/leaflet/dist/images/" ;

                    if(this.map){
                        this.map.remove() ;
                    }

                    this.map = L.map(this.div).setView(this.centerCoords, this.zoom);

                    this.markersGroups = L.markerClusterGroup();

                    
                    this.map.on('click', (e)=>{
                        e.originalEvent.stopPropagation() ;
                        this.dispatchEvent(new CustomEvent("click", { bubbles: true, detail: e}));
                    });
                    
                    
                    this.render() ;

                    new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                          if(entry.intersectionRatio > 0) {
                            //this.render();
                            window.dispatchEvent(new Event('resize'));

                            observer.disconnect();
                          }
                        });
                    }).observe(this);
                }) ;
            }

            render(){
                this.renderLayer() ;
                this.map.addLayer(this.markersGroups);
                
                this.renderMarkers() ;
                this.renderCircles() ;
                this.renderPolygons() ;
            }

            renderLayer(){
                if(!this.map){ return ; }
                if(this.layer){
                    this.map.removeLayer(this.layer);
                }
                const L = this.ownerDocument.defaultView.L ;
                this.layer = L.tileLayer.provider(this.tileProvider).addTo(this.map);
            }

            renderMarkers(){
                if(!this.map){ return ; }
                const L = this.ownerDocument.defaultView.L ;
                const markers = this.querySelectorAll("z-map-marker") ;
                this.markersGroups.clearLayers() ;
                for(let elMarker of markers){
                    if(elMarker.marker && elMarker.hasAttribute("z-no-group")){
                        elMarker.marker.remove() ;
                        // this.markersGroups.removeLayer(elMarker.marker) ;
                    }
                    let coords = this.centerCoords ;
                    if(elMarker.getAttribute("z-lat") && elMarker.getAttribute("z-lng")){
                        if(!isNaN(Number(elMarker.getAttribute("z-lat"))) && !isNaN(Number(elMarker.getAttribute("z-lng")))){
                            coords = [
                                Number(elMarker.getAttribute("z-lat")), 
                                Number(elMarker.getAttribute("z-lng"))
                            ];
                        }
                    }
                    let options = {} ;
                    if(elMarker.hasAttribute("z-icon") || elMarker.hasAttribute("z-fill-color")){
                        options.icon = L.icon.fontAwesome({
                            iconClasses: elMarker.getAttribute("z-icon")||"",
                            markerColor: elMarker.getAttribute("z-fill-color")||"#2880ca",
                            markerFillOpacity: Number(elMarker.getAttribute("z-fill-opacity")||1),
                            // markerStrokeWidth: 1,
                            // markerStrokeColor: "grey",
                            iconColor: elMarker.getAttribute("z-icon-color")||"#FFFFFF"
                          }) ;
                    }

                    let attrs = elMarker.attributes ;
                    for(let attr of attrs){
                        if(/^z-marker-option-/.test(attr.name)){
                            let optName = attr.name.replace(/^z-marker-option-/, "").split("-").map((v, i)=>{
                                if(i>0){
                                    return v.substring(0,1).toUpperCase()+v.substring(1) ;
                                }else{
                                    return v ;
                                }
                            }).join("") ;
                            let value = attr.value ;
                            if(value === "true"){ 
                                value = true ; 
                            }else if(value === "false"){ 
                                value = false ; 
                            }else if(value && 
                                (
                                    (value[0] === "{" && value[value.length -1]=== "}") ||
                                    (value[0] === "[" && value[value.length -1]=== "]") 
                                )){
                                    try{
                                        value = JSON.parse(value) ;
                                    }catch(e){
                                        console.error("WRONG VALUE "+value, e) ;
                                    }
                            }
                            if(value.indexOf && value.indexOf("func:") === 0){
                                try{
                                    value = runInContext(this, {}, value.replace("func:", "")) ;
                                }catch(err){
                                    console.error("Error while running ", value, err);
                                }
                            }
                            const optPath = optName.split(".") ;
                            let optObject = options;
                            while(optPath.length>1){
                                const p = optPath.shift() ;
                                if(!optObject[p]){
                                    optObject[p] = {} ;
                                }
                                optObject = optObject[p] ;
                            }
                            optObject[optPath.shift()] = value ;
                        }
                    }


                    elMarker.marker = L.marker(coords, options) ;
                    elMarker.marker.on('click', (e)=>{
                        e.originalEvent.stopPropagation() ;
                        elMarker.dispatchEvent(new CustomEvent("click", { bubbles: true, detail: e}));
                    });

                    const elPopup = elMarker.querySelector("z-map-popup") ;
                    if(elPopup){
                        elMarker.marker.bindPopup(elPopup.innerHTML) ;
                    }
                    if(elMarker.hasAttribute("z-no-group")){
                        elMarker.marker.addTo(this.map) ;
                    }else{
                        this.markersGroups.addLayer(elMarker.marker);
                    }
                    // elMarker.marker.addTo(this.map) ;
                }
            }
            renderCircles(){
                if(!this.map){ return ; }
                const L = this.ownerDocument.defaultView.L ;
                const circles = this.querySelectorAll("z-map-circle") ;
                for(let elCircle of circles){
                    if(elCircle.circle){
                        elCircle.circle.remove();
                    }
                    let coords = this.centerCoords ;
                    if(elCircle.getAttribute("z-lat") && elCircle.getAttribute("z-lng")){
                        if(!isNaN(Number(elCircle.getAttribute("z-lat"))) && !isNaN(Number(elCircle.getAttribute("z-lng")))){
                            coords = [
                                Number(elCircle.getAttribute("z-lat")), 
                                Number(elCircle.getAttribute("z-lng"))
                            ];
                        }
                    }
                    elCircle.circle = L.circle(coords, {
                        color: elCircle.getAttribute("z-color")||"red",
                        fillColor: elCircle.getAttribute("z-fill-color")||'#f03',
                        fillOpacity: Number(elCircle.getAttribute("z-fill-opacity")||0.5),
                        radius: Number(elCircle.getAttribute("z-radius")||500),
                    }) ;

                    elCircle.circle.on('click', (e)=>{
                        e.originalEvent.stopPropagation() ;
                        elCircle.dispatchEvent(new CustomEvent("click", { bubbles: true, detail: e}));
                    });

                    const elPopup = elCircle.querySelector("z-map-popup") ;
                    if(elPopup){
                        elCircle.circle.bindPopup(elPopup.innerHTML) ;
                    }

                    elCircle.circle.addTo(this.map) ;
                }
            }
            renderPolygons(){
                if(!this.map){ return ; }
                const L = this.ownerDocument.defaultView.L ;
                const polygons = this.querySelectorAll("z-map-polygon") ;
                for(let elPolygon of polygons){
                    if(elPolygon.polygon){
                        elPolygon.polygon.remove() ;
                    }
                    const points = (elPolygon.getAttribute("z-points")||"").split(",") ;
                    const polygonPoints = [];
                    let p = [] ;
                    for(let i=0; i<points.length; i++){
                        p.push(Number(points[i].trim())) ;
                        if(i%2 !== 0){
                            polygonPoints.push(p) ;
                            p = [] ;
                        }
                    }

                    elPolygon.polygon = L.polygon(polygonPoints, {
                        color: elPolygon.getAttribute("z-color")||"blue",
                        fillColor: elPolygon.getAttribute("z-fill-color")||'#03f',
                        fillOpacity: Number(elPolygon.getAttribute("z-fill-opacity")||0.5),
                    }) ;

                    elPolygon.polygon.on('click', (e)=>{
                        e.originalEvent.stopPropagation() ;
                        elPolygon.dispatchEvent(new CustomEvent("click", { bubbles: true, detail: e}));
                    });

                    const elPopup = elPolygon.querySelector("z-map-popup") ;
                    if(elPopup){
                        elPolygon.polygon.bindPopup(elPopup.innerHTML) ;
                    }

                    elPolygon.polygon.addTo(this.map) ;
                }
            }


            doImport() {
                
                let rootNode = this.getRootNode();
                if(rootNode === this) { return Promise.resolve(); }
                if(!rootNode || !rootNode.getElementById){ return Promise.resolve(); }

                let head = rootNode;
                if(rootNode.head){
                    head = rootNode.head ;
                }

                const styleTag = rootNode.getElementById("style_z_map") ;
                if(styleTag){ return rootNode.importLeafletPromise; }

                let s = document.createElement("link");
                s.rel = "stylesheet";
                s.type = "text/css";
                s.href = "/node_modules/leaflet/dist/leaflet.css";
                
                head.appendChild(s);

                s = document.createElement("link");
                s.rel = "stylesheet";
                s.type = "text/css";
                s.href = "/node_modules/leaflet-fa-markers/L.Icon.FontAwesome.css";
                
                head.appendChild(s);
                
                s = document.createElement("link");
                s.rel = "stylesheet";
                s.type = "text/css";
                s.href = "/node_modules/leaflet.markercluster/dist/MarkerCluster.css";
                
                head.appendChild(s);
                
                s = document.createElement("link");
                s.rel = "stylesheet";
                s.type = "text/css";
                s.href = "/node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";
                
                head.appendChild(s);

                var sInline = document.createElement('style');
                sInline.id = "style_z_map" ;
                sInline.setAttribute('type', 'text/css');
                sInline.appendChild(document.createTextNode(`
                    z-map { display: block; min-width: 200px; min-heigth: 200px; width: 200px; height: 200px }
                    div[class^="col-"] z-map { width: 100% }
                    .z-map-container { width: 100%; height: 100% }
                    z-map-popup { display: none; }
                    z-map .leaflet-fa-markers .feature-icon {
                        font-size: 15px;
                    }
                `));
                head.appendChild(sInline);
                
                rootNode.importLeafletPromise = new Promise((resolve, reject)=>{
                    let script = document.createElement("script");
                    script.async = true;
                    script.type = "text/javascript";
                    script.src = "/node_modules/leaflet/dist/leaflet.js";
                    script.onload = function(_, isAbort) {
                        if (!script.readyState || "complete" === script.readyState) {
                            if (isAbort){
                                reject("can't load leaflet") ;
                            }else{
                                let script = document.createElement("script");
                                script.async = true;
                                script.type = "text/javascript";
                                script.src = "/node_modules/leaflet-providers/leaflet-providers.js";
                                script.onload = function(_, isAbort) {
                                    if (!script.readyState || "complete" === script.readyState) {
                                        if (isAbort){
                                            reject("can't load leaflet") ;
                                        }else{
                                            let script = document.createElement("script");
                                            script.async = true;
                                            script.type = "text/javascript";
                                            script.src = "/node_modules/leaflet-fa-markers/L.Icon.FontAwesome.js";
                                            script.onload = function(_, isAbort) {
                                                if (!script.readyState || "complete" === script.readyState) {
                                                    if (isAbort){
                                                        reject("can't load leaflet") ;
                                                    }else{
                                                        let script = document.createElement("script");
                                                        script.async = true;
                                                        script.type = "text/javascript";
                                                        script.src = "/node_modules/leaflet.markercluster/dist/leaflet.markercluster.js";
                                                        script.onload = function(_, isAbort) {
                                                            if (!script.readyState || "complete" === script.readyState) {
                                                                if (isAbort){
                                                                    reject("can't load leaflet") ;
                                                                }else{
                                                                    resolve() ;
                                                                }
                                                            }
                                                        };
                                                        
                                                        script.onreadystatechange = script.onload ;
                                                        
                                                        script.onerror = function () {
                                                            reject("can't load leaflet") ;
                                                        };
                                                        
                                                        head.appendChild(script);
                                                    }
                                                }
                                            };
                                            
                                            script.onreadystatechange = script.onload ;
                                            
                                            script.onerror = function () {
                                                reject("can't load leaflet") ;
                                            };
                                            
                                            head.appendChild(script);
                                        }
                                    }
                                };
                                
                                script.onreadystatechange = script.onload ;
                                
                                script.onerror = function () {
                                    reject("can't load leaflet") ;
                                };
                                
                                head.appendChild(script);
                            }
                        }
                    };
                    
                    script.onreadystatechange = script.onload ;
                    
                    script.onerror = function () {
                        reject("can't load leaflet") ;
                    };
                    
                    head.appendChild(script);
                }) ;
                return rootNode.importLeafletPromise;
            }

            get tileProvider(){
                return this.getAttribute("z-tile-provider")||"OpenStreetMap.Mapnik";
            }
            set tileProvider(tileProvider){
                this.setAttribute("z-tile-provider", tileProvider);
            }
            get centerCoords(){
                return (this.getAttribute("z-center-coords")||"51.505,-0.09").split(",");
            }
            set centerCoords(coords){
                if(Array.isArray(coords)){
                    coords = coords.join(",");
                }
                this.setAttribute("z-center-coords", coords);
            }
            
            get zoom(){
                return Number(this.getAttribute("z-zoom")||13);
            }
            set zoom(zoom){
                this.setAttribute("z-zoom", zoom);
            }

            applyCoordsAndZoom(){
                if(!this.map){ return ;}
                this.map.setView(this.centerCoords, this.zoom) ;
            }

            static get observedAttributes() {
                return ["z-center-coords", "z-zoom", "z-tile-provider"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'z-center-coords':
                    case 'z-zoom':
                        this.applyCoordsAndZoom();
                        break;
                    case 'z-tile-provider':
                        this.renderLayer();
                        break;
                   
                }
            }
           
        }
        customElements.define(COMPONENT_NAME, MapComponent);

        class MapMarkerComponent extends HTMLElement {
            constructor() {
                super() ;
            }

            connectedCallback() {
                this.zMap = this.closest("z-map") ;
                this.renderMarker() ;
            }

            disconnectedCallback(){
                if(this.marker){
                    this.marker.remove() ;
                }
            }

            renderMarker(){
                const zMap = this.closest("z-map") ;
                if(zMap){
                    zMap.renderMarkers() ;
                }
            }

            static get observedAttributes() {
                return ["z-lat", "z-lng", "z-icon", "z-icon-color", "z-fill-color", "z-fill-opacity"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                this.renderMarker();
            }
        }
        customElements.define("z-map-marker", MapMarkerComponent);

        class MapCircleComponent extends HTMLElement {
            constructor() {
                super() ;
            }

            connectedCallback() {
                this.zMap = this.closest("z-map") ;
                this.renderCircle() ;
            }

            disconnectedCallback(){
                if(this.circle){
                    this.circle.remove() ;
                }
            }

            renderCircle(){
                const zMap = this.closest("z-map") ;
                if(zMap){
                    zMap.renderCircles() ;
                }
            }

            static get observedAttributes() {
                return ["z-lat", "z-lng", "z-color", "z-fill-color", "z-fill-opacity", "z-radius"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'z-lat':
                    case 'z-lng':
                    case 'z-color':
                    case 'z-fill-color':
                    case 'z-fill-opacity':
                    case 'z-radius':
                        this.renderCircle();
                        break;
                   
                }
            }
        }
        customElements.define("z-map-circle", MapCircleComponent);
        
        class MapPolygonComponent extends HTMLElement {
            constructor() {
                super() ;
            }

            connectedCallback() {
                this.zMap = this.closest("z-map") ;
                this.renderPolygon() ;
            }

            disconnectedCallback(){
                if(this.polygon){
                    this.polygon.remove() ;
                }
            }

            renderPolygon(){
                const zMap = this.closest("z-map") ;
                if(zMap){
                    zMap.renderPolygons() ;
                }
            }

            static get observedAttributes() {
                return ["z-points", "z-color", "z-fill-color", "z-fill-opacity"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'z-points':
                    case 'z-color':
                    case 'z-fill-color':
                    case 'z-fill-opacity':
                        this.renderPolygon();
                        break;
                   
                }
            }
        }
        customElements.define("z-map-polygon", MapPolygonComponent);
        
        class MapPopupComponent extends HTMLElement {
            constructor() {
                super() ;
            }
        }
        customElements.define("z-map-popup", MapPopupComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
